import { LiveSwitchAction } from "../../../LiveSwitch/liveSwitchActions";
import * as LSTypes from "../../../LiveSwitch/liveSwitchActionTypes";
import initialState from "./initialState";
import { CurrentMentorsActions } from "../actions/currentClientActions";
import * as types from "../actions/actionTypes";
import { RecordingOption } from "../../../Shared/GeneratedTypes";

export default function recordingStateReducer(
    state: boolean = initialState.recordingState,
    action: CurrentMentorsActions | LiveSwitchAction
): boolean {
    switch (action.type) {
        case types.LOAD_CURRENT_MENTORS_BY_ID_SUCCESS: {
            if (action.session.order.sessionRecorded === RecordingOption.Never) {
                return false;
            } else if (action.session.order.sessionRecorded === RecordingOption.Always) {
                return true;
            } else if (
                action.session.sessionInfo.recordingToggles &&
                action.session.sessionInfo.recordingToggles.length
            ) {
                return action.session.sessionInfo.recordingToggles[
                    action.session.sessionInfo.recordingToggles.length - 1
                ].isRecording;
            }
            return !action.session.order.startSessionPaused;
        }
        case LSTypes.RECORDING_TOGGLED: {
            return action.isRecording;
        }
    }
    return state;
}
